import React, { useCallback, useEffect, useState } from 'react';
import { useAppContext } from '/@contexts/global-app-context';
import { useCreateCollectionMutation } from '/@services/collections/collection-service';
import { CreateEditModal } from '../collections/create-edit-modal/create-edit-modal.container';
import { CreateLiveboardModal } from '../home/home-left-panel/create-liveboard-modal.container';

export const SPOTLIGHT_CREATE_LIVEBOARD_EVENT = 'spotlight:create-liveboard';
export const SPOTLIGHT_CREATE_COLLECTION_EVENT = 'spotlight:create-collection';

export const SpotlightCreateModalsContainer: React.FC = () => {
    const { navService, sessionService } = useAppContext();
    const {
        createCollection,
        data: createCollectionData,
        loading: createCollectionLoading,
    } = useCreateCollectionMutation();

    const [showLiveboard, setShowLiveboard] = useState(false);
    const [showCollection, setShowCollection] = useState(false);

    const openLiveboardModal = useCallback(() => setShowLiveboard(true), []);
    const openCollectionModal = useCallback(() => setShowCollection(true), []);

    useEffect(() => {
        window.addEventListener(
            SPOTLIGHT_CREATE_LIVEBOARD_EVENT,
            openLiveboardModal,
        );
        window.addEventListener(
            SPOTLIGHT_CREATE_COLLECTION_EVENT,
            openCollectionModal,
        );
        return () => {
            window.removeEventListener(
                SPOTLIGHT_CREATE_LIVEBOARD_EVENT,
                openLiveboardModal,
            );
            window.removeEventListener(
                SPOTLIGHT_CREATE_COLLECTION_EVENT,
                openCollectionModal,
            );
        };
    }, [openLiveboardModal, openCollectionModal]);

    useEffect(() => {
        if (createCollectionData && createCollectionData.Status <= 300) {
            setShowCollection(false);
            navService.goToCollection(createCollectionData.Data.id);
        }
    }, [createCollectionData, navService]);

    return (
        <>
            <CreateLiveboardModal
                isModalOpen={showLiveboard}
                setIsModalOpen={setShowLiveboard}
                navService={navService as any}
                sessionService={sessionService as any}
            />
            {showCollection && (
                <CreateEditModal
                    isModalOpened={showCollection}
                    closeModal={() => setShowCollection(false)}
                    setShowError={Function.prototype as any}
                    loader={createCollectionLoading}
                    onSubmit={formData => createCollection(formData)}
                />
            )}
        </>
    );
};
